<template>
  <div>
    <b-card>
      <b-card-header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <b-card-title class="mb-0">Training Overview</b-card-title>
          <div class="d-flex align-items-center">
            <b-form-input
              type="number"
              class="mr-1"
              style="width: 120px"
              v-model.number="filters.year"
              @change="loadOverview"
              :min="2000"
              :max="2099"
            />
            <v-select
              class="mr-1 filter-select"
              :options="companies"
              :multiple="true"
              label="label"
              v-model="filters.company"
              @input="loadOverview"
              placeholder="Companies"
            />
            <b-button size="sm" class="mr-1" variant="outline-primary" @click="selectAllCompanies">Select All</b-button>
            <v-select
              class="mr-1 filter-select"
              :options="courses"
              :multiple="true"
              label="label"
              v-model="filters.course"
              @input="loadOverview"
              placeholder="Courses"
            />
            <b-button size="sm" variant="outline-primary" @click="selectAllCourses">Select All</b-button>
          </div>
        </div>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ kpis.total_events_this_year || 0 }}</div>
              <small class="text-muted">Total Events (This Year)</small>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ kpis.total_participants || 0 }}</div>
              <small class="text-muted">Total Participants</small>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ formatPercent(kpis.average_attendance_rate) }}</div>
              <small class="text-muted">Average Attendance Rate</small>
            </b-card>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h4 mb-0">{{ kpis.total_companies_participating || 0 }}</div>
              <small class="text-muted">Total Companies Participating</small>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6" lg="3" class="mb-1">
            <b-card class="text-center">
              <div class="h5 mb-0">{{ kpis.top_course_by_attendance || '-' }}</div>
              <small class="text-muted">Top Course (by attendance)</small>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import reportStoreModule from './reportStoreModule'
import vSelect from "vue-select";

export default {
    components: {
      vSelect,
    },
  name: 'TrainingOverview',
  data() {
    return {
      kpis: {},
      companies: [],
      courses: [],
      filters: {
        year: new Date().getFullYear(),
        company: [],
        course: [],
      },
    }
  },
  created() {
    const MODULE = 'trainingReports'
    if (!store.hasModule(MODULE)) store.registerModule(MODULE, reportStoreModule)
    onUnmounted(() => {
      if (store.hasModule(MODULE)) store.unregisterModule(MODULE)
    })
    this.loadOptions().then(this.loadOverview)
  },
  methods: {
    loadOptions() {
      return store.dispatch('trainingReports/getTrainingOptions').then(res => {
        this.companies = res.data.companies || []
        this.courses = res.data.courses || []
      })
    },
    selectAllCompanies() {
      this.filters.company = (this.companies || []).slice()
      this.loadOverview()
    },
    selectAllCourses() {
      this.filters.course = (this.courses || []).slice()
      this.loadOverview()
    },
    loadOverview() {
      const params = this.buildParams({ year: this.filters.year })
      store.dispatch('trainingReports/getTrainingOverview', params).then(res => {
        this.kpis = res.data.kpis || {}
      }).catch(err => {
        this.$swal({ title: 'Error', text: 'Failed to load overview: ' + err, icon: 'error' })
      })
    },
    buildParams(extra = {}) {
      const company_id = (this.filters.company || []).map(c => c.id).join(',') || undefined
      const course_id = (this.filters.course || []).map(c => c.id).join(',') || undefined
      return { ...extra, company_id, course_id }
    },
    formatPercent(v) {
      if (v === null || v === undefined) return '0%'
      return `${Number(v).toFixed(2)}%`
    },
  },
}
</script>

<style scoped>
.h4 { font-weight: 600; }
.filter-select { min-width: 260px; width: 320px; }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>

